import { apiSlice } from '../../api/slice'

export const listDropsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllDrops: builder.query({
      query: ({ search, limit, offset, status, sort }) => ({
        url: `/drops/guest/all`,
        params: {
          search,
          limit,
          offset,
          status,
          sort,
        },
      }),
    }),
    getDropBySlug: builder.query({
      query: ({ slug }) => ({
        url: `/drops/guest/${slug}`,
      }),
    }),
  }),
})

export const {
  useGetAllDropsQuery,
  useLazyGetAllDropsQuery,
  useGetDropBySlugQuery,
  useLazyGetDropBySlugQuery,
} = listDropsApiSlice
